// eslint-disable-next-line
function dataReportsAdapter(reportsRes) {
  const maxValue = (serie1, serie2) => {
    let iterates;
    let newIterate = 0;
    if (!serie1 || !serie2) return '';
    if (Array.isArray(serie1) && Array.isArray(serie2)) {
      serie1.forEach((element, index) => {
        iterates = element + serie2[index];
        newIterate = iterates > newIterate ? iterates : newIterate;
        return newIterate;
      });
      return newIterate;
    }
    return '';
  };

  if (!reportsRes) return null;
  if (reportsRes) {
    return {
      totalReports: reportsRes.totalReports,
      newReports: reportsRes.unreadReports,
      reportsViewed: reportsRes.readReports,
      newSeries:
        reportsRes.reportCountByType && Object.values(reportsRes.reportCountByType).map(serie => serie.unreadReports),
      viewedSeries:
        reportsRes.reportCountByType && Object.values(reportsRes.reportCountByType).map(serie => serie.readReports),
      categories:
        reportsRes.reportCountByType && Object.values(reportsRes.reportCountByType).map(serie => serie.reportTypeId),
      min: 0,
      max: maxValue(
        reportsRes.reportCountByType && Object.values(reportsRes.reportCountByType).map(serie => serie.readReports),
        reportsRes.reportCountByType && Object.values(reportsRes.reportCountByType).map(serie => serie.unreadReports)
      )
    };
  }
}

export { dataReportsAdapter };
